// Video preload options
const VIDEO_PRELOAD_OPTIONS = ["auto", "metadata", "none"] as const;

// Size units configuration
const SIZE_UNITS_BASE = ["px", "%", "rem", "em"];

const SIZE_UNITS_WIDTH = [
    ...SIZE_UNITS_BASE,
    "vw",
    "auto",
    "fit-content",
    "max-content",
    "min-content",
];

const SIZE_UNITS_HEIGHT = [
    ...SIZE_UNITS_BASE,
    "vh",
    "auto",
    "fit-content",
    "max-content",
    "min-content",
];

const SIZE_UNITS_MAX = [
    ...SIZE_UNITS_BASE,
    "vw",
    "none",
    "fit-content",
    "max-content",
    "min-content",
];

// Border radius configurations
const BORDER_RADIUS_FIELDS = [
    { key: "borderRadius" as const, label: "All" },
    { key: "borderTopLeftRadius" as const, label: "Top Left" },
    { key: "borderTopRightRadius" as const, label: "Top Right" },
    { key: "borderBottomLeftRadius" as const, label: "Bottom Left" },
    { key: "borderBottomRightRadius" as const, label: "Bottom Right" },
];

// Border style options
const BORDER_STYLES = [
    "none",
    "solid",
    "dashed",
    "dotted",
    "double",
    "groove",
    "ridge",
    "inset",
    "outset",
] as const;

// Object fit options for images
const OBJECT_FIT_OPTIONS = [
    "fill",
    "contain",
    "cover",
    "none",
    "scale-down",
] as const;

// Font family groups for categorization
const FONT_FAMILY_GROUPS = [
    { label: "System Fonts", start: 0, end: 11 },
    { label: "Google Fonts", start: 11, end: 20 },
    { label: "Serif Fonts", start: 20, end: 23 },
    { label: "Monospace Fonts", start: 23, end: -1 }, // -1 means to the end
] as const;

// CSS property categories
const CSS_PROPERTY_CATEGORIES = [
    "Typography",
    "Background",
    "Border",
    "Layout",
    "Flexbox",
    "Effects",
] as const;

// Visibility options
const VISIBILITY_OPTIONS = [
    { value: "none" as const, label: "Visible on all devices" },
    { value: "mobile" as const, label: "Hidden on mobile" },
    { value: "tablet" as const, label: "Hidden on tablet" },
    { value: "desktop" as const, label: "Hidden on desktop" },
];

export {
    VIDEO_PRELOAD_OPTIONS,
    SIZE_UNITS_WIDTH,
    SIZE_UNITS_HEIGHT,
    SIZE_UNITS_MAX,
    BORDER_RADIUS_FIELDS,
    BORDER_STYLES,
    OBJECT_FIT_OPTIONS,
    FONT_FAMILY_GROUPS,
    CSS_PROPERTY_CATEGORIES,
    VISIBILITY_OPTIONS,
};
